import { Segment } from '@landsbankinn/ui';
import React from 'react';
import { Video } from '../components/video/Video';

interface IProps {
  body_video: any;
}

export const VideoElContainer = ({ body_video }: IProps) => {
  if (!body_video?.url) {
    return null;
  }

  return (
    <Segment>
      <Video
        src={body_video?.url}
        muted={true}
        loop={true}
        width={1180}
        autoPlay
      />
    </Segment>
  );
};
